import { Logout, Menu as MenuIcon } from "@mui/icons-material";
import {
  Avatar,
  Grid,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Stack,
  Tooltip,
} from "@mui/material";
import React, { useState } from "react";
import HeaderDrawer from "./partials/Drawer";
import useApp from "../../hooks/useApp";
import PasswordIcon from '@mui/icons-material/Password';


const Header: React.FC = () => {
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const { push } = useApp();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // let user: any | null = JSON.parse(localStorage.getItem("user")!);
  // if (!user) user = { name: "Administrator" }
  const handleLogout = () => {
    handleClose();
    localStorage.clear();
    push("/login");
    return;
  };
  return (
    <Stack
      component="header"
      direction={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
      sx={{ p: 1 }}
    >
      <IconButton
        sx={{ display: { xs: "block", lg: "none" } }}
        size="small"
        onClick={() => setOpenDrawer(true)}
      >
        <MenuIcon />
      </IconButton>
      <HeaderDrawer openDrawer={openDrawer} setOpenDrawer={setOpenDrawer} />

      <Grid container justifyContent={"flex-end"} alignItems={"flex-start"}>
        <Tooltip title="Profile">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <Avatar sx={{ width: 32, height: 32 }} />
          </IconButton>
        </Tooltip>
        <div></div>
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <MenuItem onClick={handleLogout}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            {"Log Out"}
          </MenuItem>
          <MenuItem onClick={() => push('/update-password')}>
            <ListItemIcon>
              <PasswordIcon fontSize="small" />
            </ListItemIcon>
            {"Update Password"}
          </MenuItem>
        </Menu>
      </Grid>
    </Stack>
  );
};

export default Header;
